<template>
  <div>
    <center-spinner :loading="loading" />
    <div class="d-flex align-center">
      <img
        src="../../../assets/img/megaphone-label.png"
        alt=""
        width="20"
        class="mr-2"
      >
      <p class="subheader-style mb-0">
        Organization Requests
      </p>
    </div>

    <v-card
      elevation="0"
      color="white"
      class="check-in-history"
    >
      <div v-if="anyPendingRequestAvailable">
        <v-btn
          class="home-action-btn mt-2"
          color="#FFF"
          elevation="0"
          @click="toPendingRequest()"
        >
          <div>
            <v-icon color="#FF3700">
              mdi-domain
            </v-icon>
            {{ organizationsPendingRequests[0].organization.name }}.
          </div>
          <v-icon> mdi-arrow-right-circle-outline </v-icon>
        </v-btn>
      </div>
      <div
        v-else
        class="empty-alert-div mt-3"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            No new requests
          </p>
          <br>
          <br>
        </v-card>
      </div>
    </v-card>
  </div>
</template>

<script>
import spinner from '../../components/SpinnerCentre.vue';
export default {
  name: 'HomePagePendingRequest',
  components: {
    'center-spinner': spinner,
  },
  filters: {
    formatRole (val) {
      if (val === 'site-manager') {
        return 'Site Manager';
      } else if (val === 'contractor') {
        return 'Contractor';
      } else {
        return 'Worker';
      }
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    organizationsPendingRequests () {
      return this.$store.getters[
        'organization/getOrganizationsPendingRequests'
      ];
    },
    anyPendingRequestAvailable () {
      if (this.organizationsPendingRequests.length !== 0) {
        return true;
      }
      return false;
    },
  },
  mounted () {
    this.getOrganizationsPendingRequests();
  },
  methods: {
    async getOrganizationsPendingRequests () {
      this.loading = true;
      await this.$store.dispatch(
        'organization/fetchOrganizationsPendingRequests',
        {
          params: {
            requestStatus: 'pending',
          },
        },
      );
      this.loading = false;
    },
    toPendingRequest () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Organizations' });
      }, 1000);
    },
  },
};
</script>
